import React from 'react'
import { Row, Col, Tag } from 'antd'
import { config } from 'Utils';

// 展示用的 一行perRow个
class DisplayForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: props.dataSource,
      perRow: props.perRow
    };
  }

  render() {
    var self = this;

    const mapper = (item, index) => {
      var res = []
        , span_w = 24
        ;
      item.type == 'attachList' ? ( // 若为附件时
        /**
         *  附件参数说明  by: Jession
         *  type: 'attachList'  判断是否为附件List的标识
         *  id: 附件List ID，唯一
         *  orginalName: 附件名称
         *  attachId: 附件ID
         *  clickFn: 点击附件时的回调函数
         **/
        (typeof item.value == 'object') && item.value.map(x => {
          // console.log(x);
          res.push(<Tag color="blue" key={x.id} onClick={item.clickFn.bind(self, x)} style={{ marginBottom: 10 }}>
            <a href={`${config.server}/api/v1/dms/commonAttachUpload/getFileDown?id=${x.attachId}`}>
              {x.orginalName}
            </a>
          </Tag>)
        })
      ) : (
        res.push(<span key={item.label}>{item.value}</span>)
      );
      item.type == 'attachList' ? span_w : span_w = span_w / self.state.perRow;
      return (
        <Col key={index} span={item.span ? item.span : span_w}
             style={index > self.state.perRow - 1 ? { marginTop: 10 } : {}}>
          <label>{item.label}：</label>
          {
            res
          }
        </Col>
      )
    };

    return (
      <div>
        <Row style={{ background: '#fafafa', padding: 15 }}>
          {
            this.props.dataSource.map(mapper)
          }
        </Row>
      </div>
    );
  }
}

export default DisplayForm



// WEBPACK FOOTER //
// ./src/components/displayForm.js